import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import { useSelectedVehicle } from "../context/vehicle.context";
import VarList from "./VarList";
import './vehicles.css'
import { VehicleInformation } from "../data/VehInfo";

const VehSelectPopup = () => {
    const { selVehData, setSelVehData } = useSelectedVehicle();

    const vehicleInfo = VehicleInformation().platforms[selVehData.vehKey];

    const handleClose = () => {
        setSelVehData({
            ...selVehData,
            selectingVariant: false,
            vehKey: null,
            variantKey: null,
            isSelected: false
        });
    }

    const handleSelect = (variantKey) => {
        setSelVehData({
            ...selVehData,
            variantKey: variantKey,
            selectingVariant: true,
            isSelected: false
        });
    }

    const variantFeaturesContent = ()=>{
        if(!('features' in vehicleInfo.variants[selVehData.variantKey])) {
            return <p>No features available for this variant</p>;
        }

        return Object.keys(vehicleInfo.variants[selVehData.variantKey].features).map((featKey, i) => {
            return (
                <li key={i}>{featKey}: {vehicleInfo.variants[selVehData.variantKey].features[featKey] ? 'Yes' : 'No'}</li>
            )
        })
    }

    useEffect(() => {


    }, [selVehData.selectingVariant]);

    return (
        <div className="veh-select-popup popup">
            <div onClick={handleClose} className="close-btn">{'\u2715'}</div>
            <div className="header">
                <h4>Select {selVehData.vehKey} Variant {selVehData.variantKey ? ` - ${selVehData.variantKey}` : ""}</h4>
            </div>
            <div className="variants">

                <VarList vehKey={selVehData.vehKey} onVariantSelect={handleSelect} />


                <div className="variant-features">
                    <h2>{vehicleInfo.variants[selVehData.variantKey]?.description}</h2>
                    <ul>
                        {selVehData.variantKey != null ? variantFeaturesContent() : <li>Please select a variant to see features</li>}
                    </ul>
                    {/* <VehicleFeatures /> */}
                    {selVehData.variantKey? <Link to={"/vehicle-operation"}><div className="select-variant-btn" onClick={() => {
                            setSelVehData({
                                ...selVehData,
                                selectingVariant: false,
                                isSelected: true
                            });
                    }}>
                        Select Variant
                    </div></Link> : ""}
                </div>
            </div>

        </div>
    );
};

export default VehSelectPopup;
